import type { FlaggedCustomer } from '../types';

const MOCK_DATE = '2026-08-06T00:00:00Z';

const daysAgo = (days: number): string => {
  const date = new Date(MOCK_DATE);
  date.setDate(date.getDate() - days);
  return date.toISOString();
};

export const MOCK_CUSTOMERS: FlaggedCustomer[] = [
  {
    id: 'cust-001',
    name: 'Delta Commodities',
    riskScore: 96,
    reason: 'Sanctions list match',
    flaggedAt: daysAgo(1),
    status: 'active',
  },
  {
    id: 'cust-002',
    name: 'Metro Remittance Inc.',
    riskScore: 91,
    reason: 'Structuring detected across accounts',
    flaggedAt: daysAgo(2),
    status: 'active',
  },
  {
    id: 'cust-003',
    name: 'Acme Trading Co.',
    riskScore: 87,
    reason: 'Velocity limit exceeded repeatedly',
    flaggedAt: daysAgo(3),
    status: 'active',
  },
  {
    id: 'cust-004',
    name: 'Global Freight LLC',
    riskScore: 78,
    reason: 'Large transfer to high-risk jurisdiction',
    flaggedAt: daysAgo(4),
    status: 'monitoring',
  },
  {
    id: 'cust-005',
    name: 'Crown Distributors',
    riskScore: 72,
    reason: 'Multiple beneficiaries within 24 hours',
    flaggedAt: daysAgo(5),
    status: 'monitoring',
  },
  {
    id: 'cust-006',
    name: 'Pacific Exports Ltd.',
    riskScore: 65,
    reason: 'Rapid account balance change',
    flaggedAt: daysAgo(6),
    status: 'monitoring',
  },
  {
    id: 'cust-007',
    name: 'Silverline Brokers',
    riskScore: 54,
    reason: 'Geographic anomaly on login',
    flaggedAt: daysAgo(8),
    status: 'cleared',
  },
  {
    id: 'cust-008',
    name: 'Sunrise Logistics',
    riskScore: 48,
    reason: 'Round-dollar transaction pattern',
    flaggedAt: daysAgo(9),
    status: 'cleared',
  },
  {
    id: 'cust-009',
    name: 'Northern Shipping',
    riskScore: 41,
    reason: 'Unexpected weekend activity',
    flaggedAt: daysAgo(11),
    status: 'cleared',
  },
].sort((a, b) => b.riskScore - a.riskScore);

export const filterCustomersByDateRange = (
  customers: FlaggedCustomer[],
  start: string,
  end: string
): FlaggedCustomer[] => {
  const startDate = new Date(start);
  startDate.setHours(0, 0, 0, 0);
  const endDate = new Date(end);
  endDate.setHours(23, 59, 59, 999);
  return customers.filter((customer) => {
    const flaggedAt = new Date(customer.flaggedAt);
    return flaggedAt >= startDate && flaggedAt <= endDate;
  });
};
